import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";
import AcceptTerms from "../components/AcceptTerms";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", organization: "" });
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    const r = await register(form);
    setBusy(false);
    if (r.ok) nav("/portal", { replace: true });
    else setError(r.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-24" data-testid="register-page">
      <form onSubmit={submit} className="w-full max-w-md card-dark p-8 space-y-5">
        <div>
          <div className="overline text-[var(--red)] mb-2">Create an account</div>
          <h1 className="font-display text-3xl font-semibold tracking-tight">Client Portal Access</h1>
          <p className="text-sm text-[var(--text-2)] mt-2">View bookings, invoices, and project reports in one place.</p>
        </div>
        <div>
          <label className="overline mb-2 block">Full name</label>
          <input required value={form.name} onChange={(e) => set("name", e.target.value)} className="input-dark" data-testid="register-name" />
        </div>
        <div>
          <label className="overline mb-2 block">Organization</label>
          <input value={form.organization} onChange={(e) => set("organization", e.target.value)} className="input-dark" data-testid="register-org" />
        </div>
        <div>
          <label className="overline mb-2 block">Email</label>
          <input required type="email" value={form.email} onChange={(e) => set("email", e.target.value)} className="input-dark" data-testid="register-email" />
        </div>
        <div>
          <label className="overline mb-2 block">Password</label>
          <input required type="password" minLength={6} value={form.password} onChange={(e) => set("password", e.target.value)} className="input-dark" data-testid="register-password" />
        </div>
        <AcceptTerms checked={acceptedTerms} onChange={setAcceptedTerms} testId="register-accept-terms" />
        {error && <div className="text-sm text-[var(--red)]" data-testid="register-error">{error}</div>}
        <button type="submit" disabled={busy} className="btn-red w-full justify-center" data-testid="register-submit">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Create account"}
        </button>
        <div className="text-sm text-[var(--text-2)]">
          Have an account? <Link to="/login" className="link-red">Sign in</Link>
        </div>
        <div className="text-sm text-[var(--text-2)] border-t border-[var(--border)] pt-5" data-testid="register-member-portal-note">
          Grant Partnership members should use the <Link to="/member" className="link-red">Member Portal</Link> instead.
        </div>
      </form>
    </div>
  );
}
